import React, { useState } from 'react';
import './reviewsHeader.css';
import { useSelector, useDispatch } from "react-redux";
import { setReviewsAction } from "../../../redux/rootReducer";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";
import { getReviewsSagaAction } from "../../../redux/sagaActions";

const ReviewsHeader = () => {
    const dispatch = useDispatch();
    const reviews = useSelector(state => state.reviews);

    // Состояние календаря
    const [openFromCalendar, setOpenFromCalendar] = useState(false);
    const [openToCalendar, setOpenToCalendar] = useState(false);

    return (
        <>
            <div className="header__filters">
                <div className="flt__box">
                    <div className="flt__title">Начало периода</div>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenFromCalendar(!openFromCalendar);
                         } }
                    >{ reviews.date_from ? new Date(reviews.date_from).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ reviews.date_from }
                        handler={ date => {
                            dispatch(setReviewsAction({
                                ...reviews,
                                date_from: date
                            }));
                            setOpenFromCalendar(false);
                        } }
                        open={ openFromCalendar }
                        close={ () => setOpenFromCalendar(false) }
                    />
                </div>
                <div className="flt__box">
                    <div className="flt__title">Окончание периода</div>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenToCalendar(!openToCalendar);
                         } }
                    >{ reviews.date_to ? new Date(reviews.date_to).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ reviews.date_to }
                        handler={ date => {
                            dispatch(setReviewsAction({
                                ...reviews,
                                date_to: date
                            }));
                            setOpenToCalendar(false);
                        } }
                        open={ openToCalendar }
                        close={ () => setOpenToCalendar(false) }
                    />
                </div>
                <div className="flt__box">
                    <div className="button button--blue"
                        onClick={ () => {
                            dispatch(getReviewsSagaAction({
                                date_from: reviews.date_from,
                                date_to: reviews.date_to
                            }));
                        } }
                    >Применить</div>
                </div>
            </div>
        </>
    );
};

export default ReviewsHeader;